import { useEffect, useState } from "react";
import { getData, postData } from "../../helpers/api";
import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';
import TextInput from "../inputs/TextInput";
import SelectInput from "../inputs/SelectInput";
import { Button } from "antd";
import { openNotification } from "../../helpers/alerts";

const AddDeliveryCompanyKey = (props) => {
    const [deliveryCompanies, setDeliveryCompanies] = useState([])
    const {
        handleAfterAddingDeliveryCompanyKey,
        initialValue,
        isModalOpen,
        handleCancel
    } = props

    const getDeliveryCompanies = async () => {
        try {
            const res = await getData("/delivery-company")
            setDeliveryCompanies(res.data.filter((el) => el.name !== "Livreur").map((ele) => ({ value: ele.id, label: ele.name })))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getDeliveryCompanies()
    }, [])

    const saveDeliveryCompanyKey = async (values, submitProps) => {
        try {
            await postData("/delivery-company-keys", values)
            openNotification(`La société a été ajouter avec succès`, 'success')
            submitProps.resetForm()
            handleAfterAddingDeliveryCompanyKey()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    return (
        <>
            <AddElementLayout
                title={initialValue.id ? "Mis a jour la société" : "ajouter une société"}
                isModalOpen={isModalOpen}
                handleCancel={handleCancel}
                initialValue={initialValue}
                validationSchema={
                    Yup.object({
                        publicKey: Yup.string().required('required'),
                        secretKey: Yup.string().required('required'),
                        name: Yup.string().required('required'),
                        deliveryCompany: Yup.string().required('required'),
                    })
                }
                handleSubmitForm={(values, submitProps) => {
                    saveDeliveryCompanyKey(values, submitProps)
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px"
                    }}
                >
                    <SelectInput
                        name="deliveryCompany"
                        size="large"
                        placeholder={"Société"}
                        options={deliveryCompanies}
                    />
                    <TextInput
                        name="name"
                        placeholder="Nom de compte"
                        size="large"
                    />
                    <TextInput
                        name="secretKey"
                        placeholder="Secret Key"
                        size="large"
                    />
                    <TextInput
                        name="publicKey"
                        placeholder="Public Key"
                        size="large"
                    />
                    <Button size='large' type="primary" htmlType="submit">
                        {initialValue.id ? "Mis a jour la société" : "Ajouter la société"}
                    </Button>
                </div>
            </AddElementLayout>
        </>
    );
}

export default AddDeliveryCompanyKey;